const social = 
    {
        email : "alavifarzinhossein@gmail.com",
        call : "+989120339183",
        city : "Tehran, Iran",
        text : "you may also find me on these platforms",
        linkedin : "https://www.linkedin.com/in/hossein-alavi",
        github : "",
    }
export default social